import type { TypePolicy } from "@apollo/client"

export const FeatureValueType: TypePolicy = {
  keyFields: [ "ApiName", "Code" ]
}
